//      
import { getRect,                                        } from 'css-box-model';
             
       
             
                   
                       
                        
import executeClip from './clip';
import { offsetByPosition } from '../../spacing';

const scroll = (target         , frame             )          => {
  if (!frame) {
    return target;
  }

  return offsetByPosition(target, frame.scroll.diff.displacement);
};

const increase = (
  target         ,
  axis      ,
  withPlaceholder                       ,
)          => {
  if (withPlaceholder && withPlaceholder.increasedBy) {
    return {
      ...target,
      [axis.end]: target[axis.end] + withPlaceholder.increasedBy[axis.line],
    };
  }
  return target;
};

const clip = (target         , frame             )        => {
  if (frame && frame.shouldClipSubject) {
    return executeClip(frame.pageMarginBox, target);
  }
  return getRect(target);
};

              
                 
                                         
             
                     
   

export default ({
  page,
  withPlaceholder,
  axis,
  frame,
}      )                   => {
  const scrolled          = scroll(page.marginBox, frame);
  const increased          = increase(scrolled, axis, withPlaceholder);
  const clipped        = clip(increased, frame);

  return {
    page,
    withPlaceholder,
    active: clipped,
  };
};



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/state/droppable/util/get-subject.js